import { render, staticRenderFns } from "./pricingTabItemMobile.vue?vue&type=template&id=594516dd"
import script from "./pricingTabItemMobile.vue?vue&type=script&lang=js"
export * from "./pricingTabItemMobile.vue?vue&type=script&lang=js"
import style0 from "./pricingTabItemMobile.vue?vue&type=style&index=0&id=594516dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports